import { useMemo } from "react";
import { ConcreteHammerReportItem } from "../../../../utils/models";
import { getConcreteDataRange } from "../../../../utils/utilities";
import CustomSection from "../../custom-general/custom-section";
import ConcreteHammerData, { DataRange } from "./data";

interface Props {
    data: ConcreteHammerReportItem[];
    startRange: number;
    endRange: number;
}

const ConcreteHammerSummary: React.FC<Props> = ({ data, startRange, endRange }) => {
    const rangesToRender: DataRange[] = useMemo(() => {
		return getConcreteDataRange(startRange, endRange);
	}, [startRange, endRange]);

    return ( 
        <>
            {rangesToRender.map((range, index) => (
                <CustomSection sectionTitle="Concrete Test Summary">
                    <ConcreteHammerData data={data} dataRange={range} showTotal={index === 0} />
                </CustomSection>
            ))}
        </>
    );
};
 
export default ConcreteHammerSummary;